import { Component, OnInit, NgModule, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CanvasOptionsService } from 'src/app/service/canvas-options.service';
import { CANVAS_OPTIONS } from 'src/app/data/canvas-options';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import {} from 'googlemaps';
import { ScaleService } from 'src/app/service/scale.service';


@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.less']
})
export class TitleBarComponent implements OnInit {
  subscription: Subscription;
  canvasOptions: any;
  
  @ViewChild('mmcMap') mapElement: ElementRef;
  @ViewChild('mmcFileName') fileName: ElementRef;
  @ViewChild('scalePromptText') promptText: ElementRef;
  @ViewChild('mmcCanvasImage') scaleCanvas: ElementRef;
  

  lat: number = 50.0041873;
  lng: number = 19.9249742;
  zoom: number = 20;
  map: google.maps.Map;
  imgBase64:string=null;
  imgName:string=null;
  imgSize={};
  canvasSize={}
  scalePrompt=false;
  scaleLine=[];
  scaleMeters=null

  constructor(
    public canvasOptionsService: CanvasOptionsService,
    private modalService: NgbModal,    
    public scaleService: ScaleService
    ) { }

  ngOnInit() {
    this.canvasOptions = CANVAS_OPTIONS;
    this.subscription = this.canvasOptionsService.canvasOptions$.subscribe(data => {
      this.canvasOptions = data;
    });
  }

  toggleGrid(){
    this.canvasOptionsService.toggleGrid();
  }

  toggleAlign(){
    this.canvasOptionsService.toggleAlign();
  }

  toggleBackground(){
    this.canvasOptionsService.toggleBackground();
  }

  highlightScalePrompt(){
    let promptText=document.getElementById('scalePromptText');

    if(promptText.classList.contains('highlightPulse'))
      promptText.classList.remove('highlightPulse');

    promptText.classList.add('highlightPulse');
  }

  setBackgroundModal(content,action=null){
   
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

    if(action && action=='canvasModal'){
      if(this.imgBase64){
        this.setCanvas();
      }
    }
  }

  setCanvas(){
    let imageCanvas=document.getElementById('mmcCanvasImage');  
    let imageCanvasWrapper=document.getElementById('popupCanvasWrapper'); 
    imageCanvas.setAttribute('width',''+imageCanvasWrapper.offsetWidth);
    imageCanvas.setAttribute('height',''+imageCanvasWrapper.offsetHeight);
    imageCanvas.addEventListener('click',this.selectSection())
  }

  readUrl(imageInput: any){
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    let self=this;
    self.scaleLine=[]
    self.scaleMeters=null;
    let imageCanvas=document.getElementById('mmcCanvasImage');   
    let imageCanvasWrapper=document.getElementById('popupCanvasWrapper');      
    self.canvasSize={width:imageCanvasWrapper.offsetWidth,height:imageCanvasWrapper.offsetHeight}
    imageCanvas.setAttribute('width',''+imageCanvasWrapper.offsetWidth);
    imageCanvas.setAttribute('height',''+imageCanvasWrapper.offsetHeight);
    
    if (imageInput.files && imageInput.files[0]) {
      reader.onload=function(e:any){

        var srcData = e.target.result;
        self.imgBase64=srcData;        
        self.imgName=file.name;

        
        let tmpImg:HTMLImageElement=new Image()
        tmpImg.onload=function(e){
         self.imgSize={width:tmpImg.width,height:tmpImg.height}
        }
        tmpImg.src=srcData;
        // imageCanvas.style.height="popupCanvasWrapper.offsetHeight" 
        // imageCanvas.style.width="popupCanvasWrapper.offsetWidth"
        imageCanvas.addEventListener('click',self.selectSection())
      }
      reader.readAsDataURL(file);
    }
  }
  
  selectSection(){
    let self=this;
    let selectSection=function(event){
      let point = {x:(parseInt(event.offsetX)),y:(parseInt(event.offsetY))}

      if(self.scaleLine.length>=2)
        self.scaleLine=[];

      self.scaleLine.push(point);

      self.drawScaleLine(this);
      if(self.scaleLine.length>=2 && self.scaleMeters)
        self.scalePrompt=true;    
      else
        self.scalePrompt=false;   
     
    }

    return selectSection;

  }

  drawScaleLine(canvas){
    
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0,0,canvas.width,canvas.height)
    ctx.beginPath();

    if(this.scaleLine[0]){
      ctx.moveTo(this.scaleLine[0].x,this.scaleLine[0].y);
     }   
    if(this.scaleLine[1]){
      ctx.lineTo(this.scaleLine[1].x,this.scaleLine[1].y);
    }
    ctx.closePath();
      ctx.strokeStyle = "red";  
      ctx.lineWidth = 2;
      ctx.stroke();

    if(this.scaleLine[0]){
      ctx.beginPath();
        ctx.arc(this.scaleLine[0].x, this.scaleLine[0].y, 3, 0, 2 * Math.PI);
        ctx.fillStyle = 'red';
        ctx.fill();
      ctx.closePath();
     }   
    if(this.scaleLine[1]){
      ctx.beginPath();
        ctx.arc(this.scaleLine[1].x, this.scaleLine[1].y, 3, 0, 2 * Math.PI);
        ctx.fillStyle = 'red';
        ctx.fill();
      ctx.closePath();
    }
     
  }


  setBackgroundImage(){
    let lenX=this.scaleLine[1].x-this.scaleLine[0].x;
    let lenY=this.scaleLine[1].y-this.scaleLine[0].y; 

    let length : number = Math.round(Math.sqrt(lenX*lenX+lenY*lenY));
    
    let size=this.calculateSize(this.imgSize,this.canvasSize);
    let scale=this.calculateScale(size,this.imgSize);
    length*=scale;
    let metersPerPx=this.scaleMeters/length
    this.canvasOptions.imageMetersPerPx=metersPerPx;

    this.canvasOptionsService.setBackgroundImage(this.imgBase64);
    this.modalService.dismissAll();
  }

  calculateSize(orgSize, targetSize){
    let newSize={width:targetSize.width,height:targetSize.height}

    let scale=this.calculateScale(orgSize, targetSize);
    newSize.width=orgSize.width*scale;
    newSize.height=orgSize.height*scale;
    
    return newSize
  }

  calculateScale(orgSize, targetSize){
    let newSize={width:targetSize.width,height:targetSize.height}

    let scale=targetSize.width/orgSize.width<targetSize.height/orgSize.height?targetSize.width/orgSize.width:targetSize.height/orgSize.height;
    return scale;
  }

  getCoordinates(adres){
    
    if(adres==null || adres == '' || adres == ' ')
      return false;
      
    var self=this;
    $.getJSON('https://maps.googleapis.com/maps/api/geocode/json?address='+adres+'&key=AIzaSyCy_3obhzGEVgUWIVKZnmhkyjL9UKKy90M', function(data) {
      ;
      self.lat = data.results[0].geometry.location.lat;
      self.lng = data.results[0].geometry.location.lng;
      // self.zoom = 20;
    });

    
  }

  mapClicked(map){
    
    
    
    this.lat = map.coords.lat;
    this.lng = map.coords.lng;
  }

  changeTilt(map){ 
       
    map.setTilt(0);
    // this._map = map;
    // this._map.setTilt(0);
  }

  getImageFromMap(){
    var self=this;
    let image = new Image();
    image.crossOrigin = "Anonymous";
    let canvas = document.createElement('canvas');
    image.onload=function(){
      canvas.width=640;
      canvas.height=400;
      let ctx=canvas.getContext('2d');
      ctx.drawImage(image,0,0);
      self.canvasOptionsService.setMapData({zoom:self.zoom,lat:self.lat,lng:self.lng,image:canvas.toDataURL()});
      self.modalService.dismissAll();
      self.scaleService.setMetersPerPx(156543.03392 * Math.cos(self.lat * Math.PI / 180) / Math.pow(2, self.zoom));
    }
    // this.zoom=20
    let url='https://maps.googleapis.com/maps/api/staticmap?center='+this.lat+','+this.lng+'&zoom='+this.zoom+'&scale=1&size=640x400&maptype=satellite&key=AIzaSyCy_3obhzGEVgUWIVKZnmhkyjL9UKKy90M';
    

    image.src=url;
    
  }
}